import { Group, NumberFormatter, Paper, SimpleGrid, Text } from '@mantine/core';
import {
  IconUserPlus,
  IconDiscount2,
  IconReceipt2,
  IconCoin,
  IconArrowUpRight,
  IconArrowDownRight
} from '@tabler/icons-react';
import classes from './HeaderStats.module.css';
import { useTranslation } from 'react-i18next';
import { formatMoneyString } from '../../../utils/strings';

const icons = {
  user: IconUserPlus,
  discount: IconDiscount2,
  receipt: IconReceipt2,
  coin: IconCoin
};

export default function HeaderStats({
  data
}: {
  annualReport: {
    collectedOrders: number;
    ordersCount: number;
    paid: number;
    sales: number;
    unpaid: number;
    orders: {
      [key: string]: number;
    };
  };
}) {
  const { t } = useTranslation(['ReportsPage', 'FieldName', 'CommonButtons', 'Notifications']);
  const annualData = [
    {
      title: t('ReportsPage:annualReport.sales'),
      icon: 'coin',
      value: formatMoneyString((data?.annualReport?.sales || 0).toFixed(2)),
      diff: 0,
      backgroundColor: '#4CAF50',
      showDiff: false
    },
    {
      title: t('ReportsPage:annualReport.ordersCount'),
      icon: 'receipt',
      value: <NumberFormatter value={data?.annualReport?.ordersCount} thousandSeparator />,
      diff: 0,
      backgroundColor: '#2196F3',
      showDiff: false
    },
    {
      title: t('ReportsPage:annualReport.unpaid'),
      icon: 'coin',
      value: formatMoneyString((data?.annualReport?.unpaid || 0).toFixed(2)),
      diff: 0,
      backgroundColor: '#FF9800',
      showDiff: false
    },
    {
      title: t('ReportsPage:annualReport.collectedOrders'),
      icon: 'receipt',
      value: <NumberFormatter value={data?.annualReport?.collectedOrders} thousandSeparator />,
      diff: 0,
      backgroundColor: '#03A9F4',
      showDiff: false
    }
  ] as const;

  const stats = annualData?.map((stat) => {
    const Icon = icons[stat.icon];
    const DiffIcon = stat.diff > 0 ? IconArrowUpRight : IconArrowDownRight;
    return (
      <Paper withBorder p="md" radius="md" key={stat.title} bg={stat.backgroundColor}>
        <Group justify="space-between">
          <Text size="xs" className={classes.title}>
            {stat.title}
          </Text>
          <Icon className={classes.icon} size="1.4rem" stroke={1.5} />
        </Group>
        <Group align="flex-end" gap="xs" mt={25}>
          <Text className={classes.value}>{stat.value}</Text>
          {stat.showDiff && (
            <Text c={stat.diff > 0 ? 'teal' : 'red'} fz="sm" fw={500} className={classes.diff}>
              <span>{stat.diff}%</span>
              <DiffIcon size="1rem" stroke={1.5} />
            </Text>
          )}
        </Group>
        <Text fz="xs" mt={7} c="white">
          Conteo Anual
        </Text>
      </Paper>
    );
  });
  return (
    <div className={classes.root}>
      <SimpleGrid cols={{ base: 1, xs: 2, md: 4 }}>{stats}</SimpleGrid>
    </div>
  );
}
